import FileManager from './FileManager';

export default FileManager;
